//
// Copyright 2026 DXOS.org
//

import * as Context from 'effect/Context';
import * as Rpc from 'effect/rpc/Rpc';
import type * as RpcClient from 'effect/rpc/RpcClient';
import * as RpcGroup from 'effect/rpc/RpcGroup';

import {
  QueryAgentStatusResponseSchema,
  QueryEdgeStatusResponseSchema,
} from './buf/proto/gen/dxos/client/services_pb.ts';
import { bufMessage, serviceError } from './service-rpc.ts';

/**
 * Effect RPC definitions for the EDGE agent service (formerly `dxos.client.services.EdgeAgentService`).
 * All methods take no payload; responses reuse the shared `QueryEdgeStatusResponse` /
 * `QueryAgentStatusResponse` proto types.
 */
export class Rpcs extends RpcGroup.make(
  Rpc.make('queryEdgeStatus', {
    success: bufMessage(QueryEdgeStatusResponseSchema),
    error: serviceError,
    stream: true,
  }),
  Rpc.make('createAgent', {
    error: serviceError,
  }),
  Rpc.make('queryAgentStatus', {
    success: bufMessage(QueryAgentStatusResponseSchema),
    error: serviceError,
    stream: true,
  }),
).prefix('EdgeAgentService.') {}

export interface Client extends RpcClient.RpcClient<RpcGroup.Rpcs<typeof Rpcs>> {}

export interface Handlers extends RpcGroup.HandlersFrom<RpcGroup.Rpcs<typeof Rpcs>> {}

/**
 * Effect service tag for the `EdgeAgentService` RPC handlers.
 */
export class Tag extends Context.Service<Tag, Handlers>()('@dxos/protocols/rpc/EdgeAgentService') {}
